import { render, staticRenderFns } from "./ClientTablePrint.vue?vue&type=template&id=3326636b&"
import script from "./ClientTablePrint.vue?vue&type=script&lang=js&"
export * from "./ClientTablePrint.vue?vue&type=script&lang=js&"
import style0 from "./ClientTablePrint.vue?vue&type=style&index=0&id=3326636b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports